import { ChatRequest, ChatResponse, RatingRequest } from '../types'

export async function sendChatMessage(
  endpoint: string,
  request: ChatRequest
): Promise<ChatResponse> {
  const response = await fetch(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
  })

  if (!response.ok) {
    throw new Error('Chat request failed')
  }

  return response.json()
}

export async function submitChatRating(
  endpoint: string,
  request: RatingRequest
): Promise<void> {
  const response = await fetch(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
  })

  if (!response.ok) {
    throw new Error('Rating submission failed')
  }
}
